import HadithCommentaryResultItem from './HadithCommentaryResultItem';

export default HadithCommentaryResultItem;
